/**
 * Carga html2canvas cuando alguien va a imprimir, no al arrancar la aplicación.
 *
 * Con sus dependencias anidadas son unos 200 KB, y sólo hacen falta en el
 * instante en que un ticket se convierte a imagen. Los cinco sitios que la usan
 * lo hacen dentro de una función `async`, así que la conversión es mecánica: en
 * vez de importarla arriba, se pide acá.
 *
 * El `webpackPrefetch` no es opcional en este proyecto: el service worker sólo
 * pre-cachea el armazón, no los trozos de JavaScript, y esos se guardan recién
 * cuando se piden. Sin prefetch, una caja que nunca imprimió estando en línea se
 * quedaría sin poder imprimir al perder la conexión — que es exactamente el
 * momento en que menos se puede permitir.
 *
 * @returns {Promise<typeof import("html2canvas").default>}
 */
export const cargarHtml2Canvas = async () =>
  (await import(/* webpackPrefetch: true */ "html2canvas")).default;
